import { TypeProjet } from '../../../../shared/constants/type-projet.enum';
import { StepCybermetrieEnum } from './step-cybermetrie.enum';

export const EMPRUNTEUR_PRINCIPAL = 'emprunteurPrincipal';
export const EMPRUNTEUR_SECONDAIRE = 'emprunteurSecondaire';

const STEPS_MPM = {
  [EMPRUNTEUR_PRINCIPAL]: {
    [StepCybermetrieEnum.ETAPE_TYPE_PROPRIETE]: 'debute',
    [StepCybermetrieEnum.AIGUILLEUR_RESIDENCE_PRINCIPALE]: 'etape-2',
    [StepCybermetrieEnum.AIGUILLEUR_CITOYENNETE]: 'etape-3',
    [StepCybermetrieEnum.AIGUILLEUR_SALARIE]: 'etape-3.5',
    [StepCybermetrieEnum.ETAPE_COEMPRUNTEUR]: 'etape-4',
    [StepCybermetrieEnum.ETAPE_CONSENTEMENT]: 'etape-5',
    [StepCybermetrieEnum.ETAPE_REVENU_BRUT]: 'etape-6',
    [StepCybermetrieEnum.ETAPE_PRIX_PROPRIETE]: 'etape-7',
    [StepCybermetrieEnum.ETAPE_REVENU_LOCATIF]: 'etape-7a',
    [StepCybermetrieEnum.ETAPE_MISE_DE_FONDS]: 'etape-8',
    [StepCybermetrieEnum.ETAPE_COORDONNEES]: 'etape-9',
    [StepCybermetrieEnum.ETAPE_VALIDATION]: 'etape-10',
    [StepCybermetrieEnum.ETAPE_CONTRE_OFFRE]: 'etape-10a',
    [StepCybermetrieEnum.ETAPE_CHOIX_TAUX]: 'etape-11',
    [StepCybermetrieEnum.ETAPE_EN_ATTENTE_COEMPRUNTEUR]: 'etape-11a'
  },
  [EMPRUNTEUR_SECONDAIRE]: {
    [StepCybermetrieEnum.ETAPE_ACCEPTER_PROJET]: 'etape-12',
    [StepCybermetrieEnum.AIGUILLEUR_SALARIE]: 'etape-13',
    [StepCybermetrieEnum.ETAPE_CONSENTEMENT]: 'etape-14',
    [StepCybermetrieEnum.ETAPE_REVENU_BRUT]: 'etape-15',
    [StepCybermetrieEnum.ETAPE_COORDONNEES]: 'etape-16',
    [StepCybermetrieEnum.ETAPE_VALIDATION]: 'etape-17',
    [StepCybermetrieEnum.ETAPE_CONTRE_OFFRE]: 'etape-17a',
    [StepCybermetrieEnum.ETAPE_CHOIX_TAUX]: 'etape-18'
  }
};

const STEPS_PME_REMPLACER = {
  [EMPRUNTEUR_PRINCIPAL]: {
    [StepCybermetrieEnum.ETAPE_TYPE_PROPRIETE]: 'debute',
    [StepCybermetrieEnum.AIGUILLEUR_CITOYENNETE]: 'etape-1.5',
    [StepCybermetrieEnum.AIGUILLEUR_MULTIPROPRIETAIRE]: 'etape-2',
    [StepCybermetrieEnum.AIGUILLEUR_SALARIE]: 'etape-3',
    [StepCybermetrieEnum.ETAPE_COEMPRUNTEUR]: 'etape-4',
    [StepCybermetrieEnum.ETAPE_CONSENTEMENT]: 'etape-5',
    [StepCybermetrieEnum.ETAPE_REVENU_BRUT]: 'etape-6',
    [StepCybermetrieEnum.ETAPE_PRIX_PROPRIETE]: 'etape-7',
    [StepCybermetrieEnum.ETAPE_MISE_DE_FONDS]: 'etape-8',
    [StepCybermetrieEnum.ETAPE_COORDONNEES]: 'etape-9',
    [StepCybermetrieEnum.ETAPE_VALIDATION]: 'etape-10',
    [StepCybermetrieEnum.ETAPE_CONTRE_OFFRE]: 'etape-10a',
    [StepCybermetrieEnum.ETAPE_CHOIX_TAUX]: 'etape-11',
    [StepCybermetrieEnum.ETAPE_EN_ATTENTE_COEMPRUNTEUR]: 'etape-11a'
  },
  [EMPRUNTEUR_SECONDAIRE]: {
    [StepCybermetrieEnum.ETAPE_ACCEPTER_PROJET]: 'etape-12',
    [StepCybermetrieEnum.AIGUILLEUR_MULTIPROPRIETAIRE]: 'etape-13',
    [StepCybermetrieEnum.AIGUILLEUR_SALARIE]: 'etape-14',
    [StepCybermetrieEnum.ETAPE_CONSENTEMENT]: 'etape-15',
    [StepCybermetrieEnum.ETAPE_REVENU_BRUT]: 'etape-16',
    [StepCybermetrieEnum.ETAPE_COORDONNEES]: 'etape-17',
    [StepCybermetrieEnum.ETAPE_VALIDATION]: 'etape-18',
    [StepCybermetrieEnum.ETAPE_CONTRE_OFFRE]: 'etape-18a',
    [StepCybermetrieEnum.ETAPE_CHOIX_TAUX]: 'etape-19'
  }
};

const STEPS_PME_SECONDAIRE = {
  [EMPRUNTEUR_PRINCIPAL]: {
    [StepCybermetrieEnum.ETAPE_TYPE_PROPRIETE]: 'debute',
    [StepCybermetrieEnum.AIGUILLEUR_CITOYENNETE]: 'etape-1.5',
    [StepCybermetrieEnum.AIGUILLEUR_MULTIPROPRIETAIRE]: 'etape-2',
    [StepCybermetrieEnum.AIGUILLEUR_SALARIE]: 'etape-3',
    [StepCybermetrieEnum.ETAPE_COEMPRUNTEUR]: 'etape-4',
    [StepCybermetrieEnum.ETAPE_CONSENTEMENT]: 'etape-5',
    [StepCybermetrieEnum.ETAPE_REVENU_BRUT]: 'etape-6',
    [StepCybermetrieEnum.ETAPE_ACHAT_A_DEUX]: 'etape-7',
    [StepCybermetrieEnum.ETAPE_MEME_COEMPRUNTEUR]: 'etape-7a',
    [StepCybermetrieEnum.ETAPE_HYPOTHEQUE]: 'etape-8',
    [StepCybermetrieEnum.ETAPE_PRIX_PROPRIETE]: 'etape-9',
    [StepCybermetrieEnum.ETAPE_MISE_DE_FONDS]: 'etape-10',
    [StepCybermetrieEnum.ETAPE_COORDONNEES]: 'etape-11',
    [StepCybermetrieEnum.ETAPE_VALIDATION]: 'etape-12',
    [StepCybermetrieEnum.ETAPE_CONTRE_OFFRE]: 'etape-12a',
    [StepCybermetrieEnum.ETAPE_CHOIX_TAUX]: 'etape-13',
    [StepCybermetrieEnum.ETAPE_EN_ATTENTE_COEMPRUNTEUR]: 'etape-13a'
  },
  [EMPRUNTEUR_SECONDAIRE]: {
    [StepCybermetrieEnum.ETAPE_ACCEPTER_PROJET]: 'etape-14',
    [StepCybermetrieEnum.AIGUILLEUR_MULTIPROPRIETAIRE]: 'etape-15',
    [StepCybermetrieEnum.AIGUILLEUR_SALARIE]: 'etape-16',
    [StepCybermetrieEnum.ETAPE_CONSENTEMENT]: 'etape-17',
    [StepCybermetrieEnum.ETAPE_REVENU_BRUT]: 'etape-18',
    [StepCybermetrieEnum.ETAPE_ACHAT_A_DEUX]: 'etape-18a',
    [StepCybermetrieEnum.ETAPE_HYPOTHEQUE]: 'etape-18b',
    [StepCybermetrieEnum.ETAPE_COORDONNEES]: 'etape-19',
    [StepCybermetrieEnum.ETAPE_VALIDATION]: 'etape-20',
    [StepCybermetrieEnum.ETAPE_CONTRE_OFFRE]: 'etape-20a',
    [StepCybermetrieEnum.ETAPE_CHOIX_TAUX]: 'etape-21'
  }
};

export const STEP_VALUES = {
  [TypeProjet.PremierAcheteur]: STEPS_MPM,
  [TypeProjet.ExperimenteRemplacer]: STEPS_PME_REMPLACER,
  [TypeProjet.ExperimenteSecondaire]: STEPS_PME_SECONDAIRE
};
